import { MDBBtn, MDBChip, MDBIcon, MDBInputGroup, MDBModalFooter, MDBSelect, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { customSearch, useAutoFocusSearchAfterLoads } from '../../../components/CustomSearchUtil/CustomSearch';
const AddToUsersTeam = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [selectedRows, setSelectedRows] = useState([]);
    const [addUsers, setAddUsers] = useState([]);
    const [removeUsers, setRemoveUsers] = useState([]);
    const [updatesourcedel, setUpdateSourceDel] = useState(false);
    const [selecteddUsers, setSelecteddUsers] = useState([]);
    const [prevaddedUsers, setPrevAddedUsers] = useState([]);
    const [sourceUsers, setSourceUsers] = useState([]);
    const [removeddUsers, setRemoveddUsers] = useState([]);
    const [searchSourceQuery, setSearchSourceQuery] = useState('');
    const [searchDetinationQuery, setSearchDetinationQuery] = useState('');
    const [addUsersExtensions, setAddUsersExtensions] = useState(new Set());
    const [sourceRecords, setSourceRecords] = useState([]);
    const [isAdminList, setisAdminList] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,true)

    let proccessdRows = [];
    sourceUsers.map((member) => {
        proccessdRows.push({
            memberInfo: member,
            username: member.username ?? "",
            extension: member.extension ?? "",
            location_name: member?.location_name ?? "",
        });
    });

    const filteredData = customSearch(sourceUsers, searchSourceQuery, [ "username", "extension", "location_name", ]);

    const basicData = {
        columns: [
            { label: "Name", field: "username", sort: true },
            { label: "Extension", field: "extension" },
            { label: "Location", field: "location_name" },
            { label: "Make Admin", field: "" },
        ],
        rows: proccessdRows,
    };





    const addUser = (selectedObj) => {
        const itemIdex = addUsers.findIndex((item) => item.extension === selectedObj.extension);
        if (itemIdex === -1) {
            if (isAdminList.includes(selectedObj.extension)) {
                selectedObj = { ...selectedObj, isAdmin: true };
            }
            const updatedUsers = [...addUsers, selectedObj];
            setAddUsers(updatedUsers);
            const addUsersextension = new Set(updatedUsers.map(item => item.extension));
            setAddUsersExtensions(addUsersextension);
        } else {
            const updateList = [...addUsers];
            updateList.splice(itemIdex, 1);
            setAddUsers(updateList);
            const addUsersextension = new Set(updateList.map(item => item.extension));
            setAddUsersExtensions(addUsersextension);
            const extensionSelect = selectedObj.extension;
           if(isAdminList.includes(extensionSelect)){
             isAdminList.splice(isAdminList.indexOf(extensionSelect), 1);  
           }
        }

        const newRemoveList = removeUsers.filter(item => item.extension !== selectedObj.extension);
        setRemoveUsers(newRemoveList);

    }

    const handleDelete = (removeObj) => {
        const updateAddList = addUsers.filter((item) => item.extension !== removeObj.extension);
        setAddUsers(updateAddList);
        const addUsersextension = new Set(updateAddList.map(item => item.extension));
        setAddUsersExtensions(addUsersextension);
        // const extensionSelect = selectedObj.extension;
        if (isAdminList.includes(removeObj.extension)) {
    isAdminList.splice(isAdminList.indexOf(removeObj.extension), 1);
  }
    }

    function setSelectAll(e) {
        e.preventDefault();
        e.stopPropagation();
         if (filteredData.length === 0) {
            return;
        }

        const addUserextension = new Set(addUsers.map(item => item.extension));
        const newAddUsers = filteredData.filter(item => !addUserextension.has(item.extension));
        let finalAddUsers = addUsers.concat(newAddUsers);
        finalAddUsers = finalAddUsers.map((user) => isAdminList.includes(user.extension) ? { ...user, isAdmin: true } : user);
        setAddUsers(finalAddUsers);
        const finaladdUserextensions = new Set(finalAddUsers.map(item => item.extension));
        setAddUsersExtensions(finaladdUserextensions);
    }

    useEffect(() => {
        if (props.sourceUsers?.length > 0 && !updatesourcedel) {
            setSelecteddUsers(props.selectedUsers);
            if (props.selectedUsers.length > 0) {
                const extensionsToFilter = new Set(props.selectedUsers.map(item => item.extension));
                const filteredSource = props.sourceUsers.filter(item => !extensionsToFilter.has(item.extension));
                setSourceUsers(filteredSource);
                setSourceRecords(filteredSource);
            } else {
                setSourceUsers(props.sourceUsers);
                setSourceRecords(props.sourceUsers);
            }

            setUpdateSourceDel(true);
            //  Trigger autofocus AFTER data is fully loaded
            if(!dataLoaded){
                setDataLoaded(true)
            }
        }
    }, [props, updatesourcedel]);

    function submitAddUsers(e) {
        props.setUpdateUsers(addUsers);
        props.setIsAddedUsers(true);
        props.onClose();
    }

    const updateSelectedStateData = (selectedState) => {
        let filteredAgents = selectedState != 'Select-Country' ? sourceRecords.filter((row) => row.location?.toString() === selectedState.toString()) ?? [] : sourceRecords
        setSourceUsers(filteredAgents);
    }

    function handleCheckBox(e, extension) {
        if (e.target.checked) {
            isAdminList.push(extension);
            const updateUSers = addUsers.map((user) => user.extension == extension ? { ...user, isAdmin: true } : user);
            setAddUsers(updateUSers);
        } else {
            isAdminList.splice(isAdminList.indexOf(extension), 1);
            const updatedUsers = addUsers.map(user => {
                if (user.extension == extension) {
                    delete user.isAdmin;
                }
                return user;
            });
            setAddUsers(updatedUsers);
        }
    }
    return (
        <>
            <div>
                {/* <div className="addAdminRole_Popup">

                    <MDBSelect className="w-100"
                        data={[
                            { text: "Select-Country", value: '-1' },
                            { text: "India", value: 'India' },
                            { text: "PAk", value: 'PAk' },
                            { text: "USA", value: 'USA' },
                            { text: "Four", value: 4 },
                            { text: "Five", value: 5 },
                            { text: "Six", value: 6 },
                            { text: "Seven", value: 7 },
                            { text: "Eight", value: 8 },
                        ]}
                        onSelect={(e) => updateSelectedStateData(e.target.value)}
                    />

                </div> */}
                <div className="pt-3">
                  {(selecteddUsers.length > 0 || addUsers.length > 0) && (
                    <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                        <input className='form-control' type='text' placeholder='Search'
                            value={searchDetinationQuery}
                            onChange={(e) => setSearchDetinationQuery(e.target.value)}
                        />
                    </MDBInputGroup>)}
                    <div className="form-group row">
                        <div className="col-12">
                            <div className="form-outlines phoneNumberheight p-0">
                                <div className="chips chips-placeholder">
                                {selecteddUsers && selecteddUsers.length > 0 || addUsers && addUsers.length > 0 ? <>
                                    {selecteddUsers && selecteddUsers.length > 0 && (
                                        customSearch(selecteddUsers, searchDetinationQuery, ["username", "extension"])
                                            .map((item) => (
                                                <MDBChip
                                                    key={item.extension} className="m-chip d-inline py-2 px-3">
                                                    {item.username} {item.isAdmin ? "(Admin)" : ""}
 
                                                </MDBChip>
                                            ))
                                    )}
                                    {addUsers && addUsers.length > 0 && (
                                         customSearch(addUsers, searchDetinationQuery, ["username", "extension"])
                                            .map((item) => (
                                                <MDBChip
                                                    onDelete={() => handleDelete(item)} className="m-chip d-inline py-2 px-3"
                                                    key={item.extension} closeIcon size="sm">
                                                    {item.username} {item.isAdmin ? "(Admin)" : ""}
                                                </MDBChip>
                                            ))
                                    )}
                                       </> : <>
                                        <p className='m-1 text-secondary'>
                                            The selected Users will appear in this section
                                        </p>
                                    </>}
                                </div>
                            </div>
                            <label className="my-3 text-primary cursor-pointer " onClick={(e) => setSelectAll(e)}>
                                {t("selectAll")}
                            </label>
                            <MDBInputGroup className='mb-3' textAfter={<MDBIcon fas icon='search' />}>
                                <input className='form-control' ref={searchRef} type='text' placeholder='Search'
                                    value={searchSourceQuery}
                                    onChange={(e) => setSearchSourceQuery(e.target.value)} />
                            </MDBInputGroup>
                            <div className="addAdminTable_height">
                                <MDBTable className="mt-3"
                                    hover
                                    itemScope
                                    small
                                >
                                    <MDBTableHead className="table-header-sticky">
                                        <tr>
                                            <th>Name</th>
                                            <th>Extension</th>
                                            <th>Location</th>
                                            <th>Admin</th>
                                        </tr>
                                    </MDBTableHead>
                                      <MDBTableBody>
                                        {filteredData.map((row, index) => (
                                                <tr
                                                    // key={row.extension}
                                                    key={`${row.extension || ''}-${index}`}
                                                    className={addUsersExtensions?.has(row.extension) ? 'addUsers-select' : ''}
                                                    onClick={() => addUser(row)}
                                                >
                                                    <td>{row.username}</td>
                                                    <td>{row.extension}</td>
                                                    <td>{row.location_name ?? ""}</td>
                                                    <td>
                                                        <>
                                                            <label className="switch" onClick={(e) => e.stopPropagation()}>
                                                                <input
                                                                    className="form-control"
                                                                    type="checkbox"
                                                                    checked={isAdminList.includes(row.extension)}
                                                                    id="AllowUsersCallerID"
                                                                    name="manage_cid"
                                                                    onChange={(e) => {
                                                                        handleCheckBox(e, row.extension)
                                                                    }
                                                                    }
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                        </>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                        {filteredData == undefined || filteredData?.length == 0 &&
                                            <td colSpan={4} className="text-center">
                                                No records found
                                            </td>
                                        }
                                    </MDBTableBody>
                                </MDBTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* <MDBModalFooter>
                <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                    {t("close")}
                </MDBBtn>
                <MDBBtn onClick={(e) => submitAddUsers(e)}>{t("add")}</MDBBtn>
            </MDBModalFooter> */}
            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => submitAddUsers(e)}>
                    {t("add")}</button>
            </div>

        </>
    )
});

export default AddToUsersTeam
